export async function getApiAuthToken(): Promise<string | null> {
  return null;
}
